export default "__VITE_ASSET__5a90c49f__"